'use strict';
/* jshint ignore:start */

var billing = {

	paymentErrorEvent: function () {
		var errors = [];
		var obj = {
			'event': 'LYPNError'
		};
		var paymentError = {
			error_location: window.pageContext.title + ' – Billing',
			error_type: 'Payment',
			error_field: 'Not Applicable',
			error_message: $('.error-message').text()
		}
		errors.push(paymentError);
		var eObj = {errors: errors};
		$.extend(obj, eObj);
		dataLayer.push(obj);
	}
};
module.exports = billing;
/* jshint ignore:end */
